import { VersaoProvider } from './../providers/versao/versao';
import { CardapioOnlineProvider } from './../providers/cardapio-online/cardapio-online';
import { LogAcoesModel } from './models/UsuarioModel';
import { AlertProvider } from './../providers/alert/alert';
import { FamiliaModel } from './models/CardapioModel';
import { MarcaModeloAgrupadoModel } from './models/MarcaModeloModel';
import { MenuModel } from './models/MenuModel';
import { ConcessionariaModel } from './models/ConcessionariaModel';
import { Component, ViewChild } from '@angular/core';
import { App, Nav, Platform, ModalController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { ConfiguracaoConcessionariaProvider } from '../providers/configuracao-concessionaria/configuracao-concessionaria';
import { ConfigHelper } from './helpers/configHelper';
import { AndroidPermissions } from '@ionic-native/android-permissions';
import { Storage } from '@ionic/storage';
import { Push, PushObject, PushOptions } from '@ionic-native/push';
import { HttpProvider } from '../providers/http/http';
import { ChecklistProvider } from '../providers/checklist/checklist';
import { Env } from '../environments/environment';
import { AppVersion } from '@ionic-native/app-version';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { FileTransfer } from '@ionic-native/file-transfer';
import { File } from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener';
import { SpinnerProvider } from './../providers/spinner/spinner';
import { SocketProvider } from '../providers/socket/socket';



@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any;
  concessionaria: ConcessionariaModel = new ConcessionariaModel();
  myProjeto: string = "camp";


  pages: Array<MenuModel>;

  count: number = 0;

  menuInicial: string = 'menu';

  lottieConfig: any;
  tipoDispositivo: string;
  dir_marcas: string;
  idFcm: string;
  form: any = {};
  idUsuario: string;
  log: LogAcoesModel = new LogAcoesModel();
  versaoAtual: string;

  permiteAcessoProdutos: boolean = false
  socket: any;

  constructor(public platform: Platform,
    private app: App,
    private transfer: FileTransfer,
    private file: File,
    private fileOpener: FileOpener,
    public statusBar: StatusBar,
    private storage: Storage,
    private confSrv: ConfiguracaoConcessionariaProvider,
    private androidPermissions: AndroidPermissions,
    private cardapioOnlineSrv: CardapioOnlineProvider,
    private httpSrv: HttpProvider,
    private push: Push,
    private checklistSrv: ChecklistProvider,
    private alertSrv: AlertProvider,
    private versaoProvider: VersaoProvider,
    private modalCtrl: ModalController,
    private appVersion: AppVersion,
    private iab: InAppBrowser,
    private spinnerSrv: SpinnerProvider,
    private socketService: SocketProvider,

  ) {
    let device = (<any>window).device;

    if (device) {
      this.form.devicename = device.name;
      this.form.so = device.version;
      this.form.devicemodel = device.model;
      this.storage.set('deviceModel', this.form.devicemodel);

    }

    if (this.platform.is('core')) {
      this.tipoDispositivo = 'browser';
    }

    if (this.platform.is('ipad')) {
      this.tipoDispositivo = 'ipad';
    }

    if (this.platform.is('android')) {
      this.tipoDispositivo = 'celular';
    }

    if (this.platform.is('tablet') && this.platform.is('android')) {
      this.tipoDispositivo = 'tablet';
    }

    if (this.platform.is('iphone')) {
      this.tipoDispositivo = 'iphone';
    }

    // if(this.tipoDispositivo != 'browser'){
    //   this.versaoProvider.verificaVersao()
    // }

    this.storage.set('dispositivo', this.tipoDispositivo);

    this.storage.get('idFcm').then(idFcm => {
      if (idFcm) {
        this.idFcm = idFcm;
      }
    });

    this.storage.get('dir_marcas').then(x => {
      if (this.platform.is('ipad') && x == "icone_marcas_fk" || this.platform.is('iphone') && x == "icone_marcas_fk") {
        this.dir_marcas = "icone_marcas_fk";
      }
      else {
        this.dir_marcas = "icone_marcas";
      }
    });

    this.initializeApp();

    platform.ready().then(() => {

      this.androidPermissions.requestPermissions(
        [
          this.androidPermissions.PERMISSION.READ_EXTERNAL_STORAGE,
          this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE,
          this.androidPermissions.PERMISSION.FOREGROUND_SERVICE,
          this.androidPermissions.PERMISSION.RECORD_AUDIO,
          this.androidPermissions.PERMISSION.CAMERA
        ]
      );

      if (this.tipoDispositivo == 'tablet' || this.tipoDispositivo == 'android') {
        this.configuracaoPushNotification();
      }
    });


    let valor = this.confSrv.isConcessionaria();

    this.lottieConfig = {
      path: 'assets/anim/menu_anim.json',
      autoplay: true,
      loop: true
    }


    this.gravaUsuarioFcm();
    if (this.tipoDispositivo != 'browser') {
      this.rootPage = 'BuscaMarcaModeloPage';
    }

    valor.then((val) => {
      if (val) {
        this.concessionaria = JSON.parse(val);
        this.rootPage = 'BuscaMarcaModeloPage';
        this.pages = new Array<MenuModel>();

        if (this.concessionaria.tipoApp == 2) // acampa shell
        {
          this.myProjeto = "acampa_shell";
        }
        else if (this.concessionaria.tipoApp == 3) // acampa ipiranga
        {
          this.myProjeto = "acampa_ipiranga";
        }
        else if (this.concessionaria.tipoApp == 4) // acampa petrobras
        {
          this.myProjeto = "acampa_petrobras";
        }
        else if (this.concessionaria.tipoApp == 5) // acampa castrol
        {
          this.myProjeto = "acampa_castrol";
        }
        else if (this.concessionaria.tipoApp == 6) // acampa ypf
        {
          this.myProjeto = "acampa_ypf";
        }
        else if (this.concessionaria.tipoApp == 7) // acampa texaco
        {
          this.myProjeto = "acampa_texaco";
        }
        else if (this.concessionaria.tipoApp == 8) // acampa camp
        {
          this.myProjeto = "acampa_camp";
        }
        else if (this.concessionaria.tipoApp == 13) // acampa total
        {
          this.myProjeto = "acampa_total";
        }
        else if (this.concessionaria.tipoApp == 28) // acampa total
        {
          this.myProjeto = "indicar_michelin";
        }

        this.pages.push({ title: 'Início', component: 'BuscaMarcaModeloPage', icon: 'star-outline', descricao: 'Ofertas por modelo' });
        this.pages.push({ title: 'Sair', component: 'LoginPage', icon: 'log-in', descricao: 'Atualize as Informações' });
        // this.pages.push({ title: 'Editar Perfil', component: 'MenuParceiroPage', icon: 'log-in', descricao: 'Atualize as Informações' });

        if (decodeURIComponent(location.href.slice(1)).includes('b2b-michelin')) {
          this.abreB2b();
        }
      }
      else if (decodeURIComponent(location.href.slice(1)).includes('b2b-michelin')) {
        this.abreB2b();
      }
      else {
        this.rootPage = 'LoginPage';
      }



      this.socketService.connect().then(socket => {
        this.socket = this.socketService.getSocket();
        console.log('Conectou: ' + Env.Env + '-alerta-geral-' + this.concessionaria.cnpj);

        this.socket.on(Env.Env + '-alerta-geral-' + this.concessionaria.cnpj, (data) => {
          console.log('Alerta geral recebido', data);
          this.alertSrv.alert(data.titulo, data.mensagem);
        });
      });
    })
    this.verificaPermissaoAcessoProdutos()
  }

  /**
   * atualizaconcessioanria
   */
  public atualizadadosconcessionaria(_concessionaria: ConcessionariaModel) {

    this.concessionaria = _concessionaria;

    this.pages = new Array<MenuModel>();

    if (this.concessionaria.codConcessionaria) {

      if (this.concessionaria.tipoApp == 2) // acampa shell
      {
        this.myProjeto = "acampa_shell";
      }
      else if (this.concessionaria.tipoApp == 3) // acampa ipiranga
      {
        this.myProjeto = "acampa_ipiranga";
      }
      else if (this.concessionaria.tipoApp == 4) // acampa petrobras
      {
        this.myProjeto = "acampa_lubrax";
      }
      else if (this.concessionaria.tipoApp == 5) // acampa castrol
      {
        this.myProjeto = "acampa_castrol";
      }
      else if (this.concessionaria.tipoApp == 6) // acampa ypf
      {
        this.myProjeto = "acampa_ypf";
      }
      else if (this.concessionaria.tipoApp == 7) // acampa texaco
      {
        this.myProjeto = "acampa_texaco";
      }
      else if (this.concessionaria.tipoApp == 8) // acampa camp
      {
        this.myProjeto = "acampa_camp";
      }
      else if (this.concessionaria.tipoApp == 13) // acampa total
      {
        this.myProjeto = "acampa_total";
      }

      this.pages.push({ title: 'Início', component: 'BuscaMarcaModeloPage', icon: 'star-outline', descricao: 'Ofertas por modelo' });
      this.pages.push({ title: 'Sair', component: 'LoginPage', icon: 'log-in', descricao: 'Atualize as Informações' });
      // this.pages.push({ title: 'Editar', component: 'MenuParceiroPage', icon: 'log-in', descricao: 'Atualize as Informações' });

    }
  }


  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleLightContent();
    });

  }

  getVersion() {
    return ConfigHelper.Version
  }
  getVersionEnv() {
    return Env.Env;
  }
  getVersionApi() {
    return ConfigHelper.ApiVersion;
  }

  openPage(page) {
    this.nav.setRoot(page.component);
    this.verificaPermissaoAcessoProdutos();
  }


  getRemove(dd: string) {
    if (dd) {
      let newString = dd.replace(/(\d*)-(\d*)-(\d*) (\d*):(\d*).*/, '$3/$2/$1 $4:$5');
      //let newString = dd.replace(/:/g,'').replace(/-/g,'').replace(/ /g,'');
      return newString;
    }
  }


  abrirEdicao() {

    this.nav.push('MenuParceiroPage', { _concessionaria: this.concessionaria, _menu: this.menuInicial, }).then(() => {
      this.nav.getActive().onDidDismiss(data => {
        // if (this.count > 1) {
        //   this.dismiss(data);
        //   this.count = 0;
        // }
        // else {
        //   this.count = 0;
        // }
      });
    });;
  }

  abrePlanos() {
    this.nav.push('ModalPlanoCompraPage', { _concessionaria: this.concessionaria, _menu: this.menuInicial });
  }

  async abreB2b() {
    try {
      var query = decodeURIComponent(location.href.slice(1));
      var url = query.split('?');
      if (url[0].includes('b2b-michelin')) {
        var partes = url[1].split('&');
        var data = {};
        partes.forEach(parte => {
          var chaveValor = parte.split('=');
          var chave = chaveValor[0];
          var valor = chaveValor[1];
          data[chave] = valor;
        });
        await this.storage.set('b2b', data);
      }
    } catch (err) {
      console.log('Problema na URL b2b', err)
    }
  }

  abreOrcamentos(status: string) {
    this.nav.push('VisualizarOrcamentosPage', { _concessionaria: this.concessionaria, _menu: this.menuInicial, _status: status, _idLoja: this.concessionaria.codConcessionaria });
  }

  abreProdutos() {
    this.nav.push('ProdutosPage', { _concessionaria: this.concessionaria, _menu: this.menuInicial, _status: status, _idLoja: this.concessionaria.codConcessionaria });
  }

  dismiss(data) {
    this.app.getRootNav().setRoot('BuscaMarcaModeloPage');
  }

  async configuracaoPushNotification() {
    console.log('### FCM ###');
    console.log('### Tentativa de cadastro ###');

    const options: PushOptions = {
      android: {
        senderID: '68356424626'
      },
      ios: {
        alert: 'true',
        badge: true,
        sound: 'false'
      }
    };

    const pushObject: PushObject = this.push.init(options);

    pushObject.on('notification').subscribe((notification: any) => console.log('Notificação recebida', JSON.stringify(notification)));
    pushObject.on('registration').subscribe((registration: any) => {
      this.idFcm = registration.registrationId;
      this.storage.set('idFcm', this.idFcm);
      console.log('Id dispositivo', this.idFcm);
      console.log('Device registered', registration.source);
    });
    pushObject.on('error').subscribe(error => console.error('Ocorreu um erro ao tentar se registrar no FCM', error));

  }

  gravaUsuarioFcm() {
    this.storage.get('idUsuario').then(idUsuario => {
      let body = {
        "idFcm": this.idFcm,
        "idUsuario": idUsuario,
        "dispositivo": this.tipoDispositivo
      };

      this.httpSrv.postApi('v1/salvaTokenFcm', body, 0).then(ResultConn => {
        if (ResultConn.success) {
          let resultado = ResultConn.data;
          console.log('Token FCM', resultado);
        }
      });
    });
  }

  async abrirManualAutomacao() {

    const { data } = await this.httpSrv.getApi(`baixarManualAutomacao/${this.concessionaria.erp}`, 1, null)
    if (data) {
      let urlpdf = "";
      if (data.linkManualAutomacao !== undefined && data.linkManualAutomacao !== null && data.linkManualAutomacao != '') {
        urlpdf = data.linkManualAutomacao;
      }

      if (this.platform.is("cordova") && urlpdf !== "") {
        const transfer = this.transfer.create();
        let path = null;
        if (this.platform.is("ios")) {
          path = this.file.documentsDirectory;
        } else if (this.platform.is("android")) {
          path = this.file.dataDirectory;
        }

        this.spinnerSrv.Show("Fazendo download do manual...");


        transfer.download(urlpdf, path + "manual.pdf").then(
          (entry) => {
            this.fileOpener.open(entry.toURL(), "application/pdf").then(() => {
              this.spinnerSrv.Hide();
            });
          },
          (error) => {
            this.spinnerSrv.Hide();
            this.alertSrv.alert(
              "Sem conexão com o Servidor",
              "Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!"
            );
          }
        );
      } else if (urlpdf !== "") {
        window.open(urlpdf, "_blank");
      } else {
        this.alertSrv.alert(
          "Nenhum manual encontrado",
          "Não foi possível encontrar manual disponível para a automação utilizada no estabelecimento."
        );
      }
    }
  }

  atualizaApp() {
    this.storage.get('idUsuario').then(idUsuario => {
      this.idUsuario = idUsuario;
      let body = {
        idUsuario: idUsuario,
        idLoja: this.concessionaria.codConcessionaria
      };

      this.verificaPermissaoAcessoProdutos();
      this.app.getRootNav().setRoot('BuscaMarcaModeloPage');
      this.httpSrv.postApi('atualizaDados', body, 0).then(ResultConn => {
        if (ResultConn.success) {
          let resultado = ResultConn.data;
          this.setLoja(resultado.dadosLoja);
        }
      });
    });

  }

  async setLoja(loja) {
    this.storage.set('idEmpresa', loja.idEmpresa);
    this.storage.set('idUsuario', this.idUsuario);
    this.storage.set('idLoja', String(loja.codConcessionaria));
    this.storage.set('tipoOferta', this.concessionaria.tipoOferta);

    this.concessionaria = <ConcessionariaModel>loja;
    this.concessionaria.consultores = [
      {
        nome: 'Denis',
        codigo: '1',
        codIntegracao: '1',
      },
      {
        nome: 'Humberto',
        codigo: '2',
        codIntegracao: '2',
      },
    ]

    if (this.concessionaria.checklist > 0) {
      let checklistEntrada = await this.checklistSrv.getQuestionarioEntrada(this.concessionaria.checklist, this.form.devicemodel);
      if (checklistEntrada) {
        this.storage.set(ConfigHelper.storageKeys.checklistEntrada, JSON.stringify(<Array<any>>checklistEntrada));
      }
    }

    if (this.concessionaria.checklist_adicional > 0) {
      let checklistAdicional = await this.checklistSrv.getQuestionarioEntrada(this.concessionaria.checklist_adicional, this.form.devicemodel);
      if (checklistAdicional) {
        this.storage.set(ConfigHelper.storageKeys.checklistAdicional, JSON.stringify(<Array<any>>checklistAdicional));
      }
    }

    let resultMarcaModelo = await this.cardapioOnlineSrv.getMarcaModelo(this.concessionaria.tipoApp);

    if (resultMarcaModelo) {
      this.storage.set(ConfigHelper.storageKeys.codConcessionaria, this.concessionaria.codConcessionaria);
      this.storage.set(ConfigHelper.storageKeys.cnpj, this.concessionaria.cnpj);
      this.storage.set(ConfigHelper.storageKeys.cpf, this.concessionaria.codAcesso);
      this.storage.set(ConfigHelper.storageKeys.atualizaautomaticamente, this.concessionaria.atualizaautomaticamente);
      this.storage.set(ConfigHelper.storageKeys.precoosagregados, this.concessionaria.precoosagregados);
      this.storage.set(ConfigHelper.storageKeys.concessionaria, JSON.stringify(this.concessionaria));
      this.storage.set(ConfigHelper.storageKeys.marcamodelo, JSON.stringify(<Array<MarcaModeloAgrupadoModel>>resultMarcaModelo));
      this.storage.set(ConfigHelper.storageKeys.cardapios, JSON.stringify(<Array<FamiliaModel>>null));

      this.alertSrv.toast('Seus dados foram atualizados!', 'bottom');

      this.atualizadadosconcessionaria(this.concessionaria);

      this.log.acao = 'Atualização do APP';
      this.confSrv.gravaLog(this.log);
      this.nav.setRoot(this.nav.getActive().component);
    }
  }


  abreTelaProdutos() {

    this.nav.push('ProdutosPage', { concessionaria: this.concessionaria });

  }

  async verificaPermissaoAcessoProdutos() {
    if (JSON.parse(await this.storage.get('permiteAcessoProdutos'))) {
      this.permiteAcessoProdutos = true;
    }
  }


  // vendaAvulsa() {
  //   console.log('venda avulsa')

  //   this.nav.push('VendaAvulsaPage', { concessionaria: this.concessionaria });

  // }

  relatorioAtendimento() {

    this.nav.push('RelatorioAtendimentoPage');

  }
  async clearHasNewComments() {
    await this.storage.remove('hasNewComments')
    await this.storage.set('hasNewComments', 0);
  }

  async abreSuporte() {
    await this.clearHasNewComments()
    const modal = this.modalCtrl.create('ChatPage', { _concessionaria: this.concessionaria });
    modal.present();
    modal.onDidDismiss(() => {
      this.clearHasNewComments()
    })
  }

  async abreClubVip() {
    this.iab.create('https://www.ipirangavip.com.br/wps/myportal/sitevip/inicio', '_system');
  }

  abreTelaHistoricoCheckup() {
    this.nav.push('HistoricoCheckupPage', { _concessionaria: this.concessionaria });
  }

  abreDashboard() {
    this.nav.push('DashboardPage', { _concessionaria: this.concessionaria })
  }

  abrirTelaDadosVipEspecialista() {
    const modal = this.modalCtrl.create('DadosVipEspecialistaPage', { _concessionaria: this.concessionaria });
    modal.present();
  }


}


// WEBPACK FOOTER //
// ./src/app/app.component.ts